module.exports = __webpack_public_path__ + "static/img/acq-5.c201bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acq-5.png
// module id = Kpiz
// module chunks = 1